const modalStyleLarge = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    borderRadius: '10px',
    boxShadow: 24,
    p: 3,
    bgcolor: 'background.paper',
  };
  
  export default modalStyleLarge;
  